import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { BuildInfoLogger } from '../../components/devtools/BuildInfoLogger';

const buildInfoRootWrapper = AppRootWrapperBlueprint.make({
  name: 'build-info-logger',
  params: {
    component: BuildInfoLogger,
  },
});

export const buildInfoModule = createFrontendModule({
  pluginId: 'app',
  extensions: [buildInfoRootWrapper],
});
